export function pegarDataHora() {
    const dataHoje = new Date();
    const horaClick = dataHoje.toLocaleTimeString();    
    const dataClick = dataHoje.toLocaleDateString();
    return { horaClick, dataClick };
}